import React from 'react';
import { howItWorks } from '../../mock';
import { Mail, KeyRound, Globe, MessageCircle, Plane, Sparkles } from 'lucide-react';

const icons = [Mail, KeyRound, Globe, MessageCircle, Plane, Sparkles];

const HowItWorks = () => {
  return (
    <section id="how" className="bg-warm py-24 md:py-32 border-y border-divider">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center reveal">
          <div className="gold-divider mb-5">
            <span className="chapter-badge text-gold uppercase">{howItWorks.eyebrow}</span>
          </div>
          <h2 className="font-serif-display text-navy text-4xl md:text-5xl leading-[1.1] font-medium">
            {howItWorks.headline}
          </h2>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-6">
          {howItWorks.steps.map((s, i) => {
            const Icon = icons[i] || Sparkles;
            return (
              <div key={s.n} className="reveal text-center relative">
                <div className="mx-auto w-16 h-16 rounded-full border border-gold/60 flex items-center justify-center bg-warm">
                  <Icon size={22} className="text-gold" />
                </div>
                <div className="mt-4 chapter-badge text-gold uppercase">Step {s.n}</div>
                <h3 className="mt-2 font-serif-display text-navy text-xl md:text-[1.35rem] leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 font-sans-body text-navy/70 text-[0.95rem] leading-relaxed">
                  {s.desc}
                </p>
                {i < howItWorks.steps.length - 1 && (
                  <div className="hidden md:block absolute top-8 -right-3 w-6 h-px bg-gold/40" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
